import { render, staticRenderFns } from "./AssignZone.vue?vue&type=template&id=370a0a42"
import script from "./AssignZone.vue?vue&type=script&lang=js"
export * from "./AssignZone.vue?vue&type=script&lang=js"
import style0 from "./AssignZone.vue?vue&type=style&index=0&id=370a0a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports